import environment from "environment";
import { getRequestService } from "@fas/cpa-state-manager/services/request";
import type { Response } from "@fas/ui-framework";
import type { PaymentHistoryData } from "../components/PaymentHistory";

const requestService = getRequestService();

export type RequestBody = {
  filters: Record<string, any>;
  sorting: {
    current: string;
    direction: unknown;
  };
  fields: Array<string>;
  page: number;
  limit: number;
};
export type ExportRequestBody = RequestBody & {
  fields: Array<{
    fieldName: string;
    name: string;
  }>;
};
type ListData = {
  data: Array<PaymentHistoryData>;
  count: number;
};
export const fetchPaymentHistoryList = (params: RequestBody) =>
  requestService
    .post(environment.endpoints.post.payoutHistory, params)
    .then(({ data }: Response<ListData>): ListData => data);
export const exportToZip = ({ filters }: RequestBody) =>
  requestService.post(
    environment.endpoints.post.payoutHistoryExport,
    {
      filters,
    },
    {
      responseType: "blob",
    }
  );
export const exportToPdf = (id: number) =>
  requestService.post(
    environment.endpoints.post.payoutHistoryExport,
    {
      filters: {
        id,
      },
    },
    {
      responseType: "blob",
    }
  );
